module.exports = __webpack_public_path__ + "common/icon-mail-default-e5f93cc543a75f0d0cce50a9fb5eb670.svg";